import React from 'react';

interface StructuredDataProps {
  type: 'website' | 'article' | 'project';
  title: string;
  description: string;
  url: string;
  image?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

const StructuredData: React.FC<StructuredDataProps> = ({
  type,
  title,
  description,
  url,
  image,
  author = "Matthew Innes",
  publishedTime,
  modifiedTime
}) => {
  const generateStructuredData = () => {
    const baseData = {
      "@context": "https://schema.org",
      "@type": type === 'website' ? 'WebSite' : type === 'article' ? 'Article' : 'CreativeWork',
      "name": title,
      "description": description,
      "url": url,
      "author": {
        "@type": "Person",
        "name": author,
        "url": "https://matthewweb.com"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Matthew Innes Portfolio",
        "url": "https://matthewweb.com"
      }
    };

    if (image) {
      baseData.image = image;
    }

    if (publishedTime) {
      baseData.datePublished = publishedTime;
    }

    if (modifiedTime) {
      baseData.dateModified = modifiedTime;
    }

    if (type === 'website') {
      return {
        ...baseData,
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://matthewweb.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      };
    }

    if (type === 'project') {
      return {
        ...baseData,
        "@type": "CreativeWork",
        "creator": {
          "@type": "Person",
          "name": author
        },
        "genre": "Web Development",
        "keywords": "web development, portfolio, project"
      };
    }

    return baseData;
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(generateStructuredData())
      }}
    />
  );
};

export default StructuredData;
